'use strict';

angular.module('more.ui.form-builder').factory('$pinHelper', ['$q', function ($q) {

  return {
    open: function () {
      return $q.resolve();
    }
  };
}]);